(function() {
  var $c40e8bb816c3e209$export$2e2bcd8739ae039 = (() => {
    if (customElements.get("slider-dots-component")) return;
    customElements.define("slider-dots-component", class SliderDotsComponent extends HTMLElement {
      connectedCallback() {
        this._parentSlider = this.closest("slider-component");
        this._onSliderInit = e => this._init(e.detail);
        this._onSliderChange = e => this._handleSliderChange(e.detail);
        this._onDotClick = e => {
          const dot = e.target.closest("[data-position-marker]");
          if (!dot) return;
          const index = parseInt(dot.getAttribute("data-position-marker"), 10);
          if (isNaN(index)) return;
          this.dispatchEvent(new CustomEvent("slider:goto", {
            detail: {
              index: index
            },
            bubbles: true
          }));
        };
        if (this._parentSlider) {
          this._parentSlider.addEventListener("slider:init", this._onSliderInit);
          this._parentSlider.addEventListener("slider:change", this._onSliderChange);
          if (this._parentSlider.slideState) this._init(this._parentSlider.slideState);
        }
        this.addEventListener("click", this._onDotClick);
      }
      disconnectedCallback() {
        if (this._parentSlider) {
          this._parentSlider.removeEventListener("slider:init", this._onSliderInit);
          this._parentSlider.removeEventListener("slider:change", this._onSliderChange);
          this._parentSlider = null;
        }
        this.removeEventListener("click", this._onDotClick);
        this._teardownDots();
      }
      _init({activeIndex: activeIndex, total: total}) {
        this._buildDots(total);
        this._updateDots(activeIndex, total);
      }
      _handleSliderChange({activeIndex: activeIndex, total: total}) {
        this._updateDots(activeIndex, total);
      }
      _teardownDots() {
        this.querySelector("[data-marker-strip]")?.remove();
        this.style.width = "";
      }
      _getDotSize(j, p, V) {
        if (j === p) return 6;
        const leftDeficit = Math.max(0, 2 - p);
        const rightDeficit = Math.max(0, 2 - (V - 1 - p));
        if (j > p) {
          const rightPos = j - p;
          return rightPos <= leftDeficit ? 6 : Math.max(2, 6 - (rightPos - leftDeficit) * 2);
        } else {
          const leftPos = p - j;
          return leftPos <= rightDeficit ? 6 : Math.max(2, 6 - (leftPos - rightDeficit) * 2);
        }
      }
      _buildDots(total) {
        this._teardownDots();
        const V = Math.min(total, 5);
        this.style.width = `${V * 17 - 8}px`;
        const strip = document.createElement("div");
        strip.setAttribute("data-marker-strip", "");
        strip.className = "flex items-center gap-2 transition-transform duration-300 ease-in-out";
        const sliderId = this._parentSlider?.querySelector('[id^="Slider-"]')?.id;
        const template = this.querySelector("[data-dot-template]");
        const goToSlideTemplate = window.MBF?.strings?.slider?.goToSlide ?? "Go to slide {{ number }}";
        for (let i = 0; i < total; i++) {
          const clone = template.content.cloneNode(true);
          const btn = clone.querySelector("[data-marker-dot]");
          btn.setAttribute("data-position-marker", i);
          btn.setAttribute("aria-label", goToSlideTemplate.replace("{{ number }}", i + 1));
          if (sliderId) btn.setAttribute("aria-controls", sliderId);
          strip.appendChild(clone);
        }
        this.appendChild(strip);
      }
      _updateDots(activeIndex, total) {
        const strip = this.querySelector("[data-marker-strip]");
        if (!strip) return;
        const V = Math.min(total, 5);
        const windowStart = Math.max(0, Math.min(activeIndex - 2, total - V));
        const p = activeIndex - windowStart;
        strip.style.transform = `translateX(-${windowStart * 17}px)`;
        strip.querySelectorAll("[data-marker-dot]").forEach((dot, i) => {
          const j = i - windowStart;
          const size = j >= 0 && j < V ? this._getDotSize(j, p, V) : 2;
          const scale = size / 6;
          const isActive = i === activeIndex;
          dot.style.transform = isActive ? `scale(${scale}) rotate(45deg)` : `scale(${scale})`;
          if (isActive) dot.setAttribute("data-active", ""); else dot.removeAttribute("data-active");
        });
      }
    });
  })();
})();